import { StepNames } from '../../../../types'
import { flowNameHelper } from './flowNameHelper'
export const screenPathHelper = (flowName: string, stepName?: string) => {
  if (flowNameHelper(flowName) === 'replacementFlow') {
    return '/MfeOobeReplacement/'
  }
  if (flowNameHelper(flowName) === 'ftmFlow') {
    return '/MfeOobeFtm/'
  }
  if (flowNameHelper(flowName) === 'connectFlow') {
    return '/MfeOobeConnect/'
  }
  if (flowNameHelper(flowName) === 'connectFinalizeFlow') {
    return '/MfeOobeConnectFinalize/'
  }
  if (flowNameHelper(flowName) === 'oobeEnrollFlow') {
    if (
      stepName === StepNames.ACCOUNT_SELECTION_STEP ||
      stepName === StepNames.REPLACEMENT_CONFIRMATION_STEP ||
      stepName === StepNames.REPLACEMENT_THANK_YOU_STEP
    ) {
      return '/MfeOobeReplacement/'
    }

    return '/MfeOobeEnroll/'
  }
}
